import { CheckboxGroup } from "../core/components/CheckboxGroup";
import { HorizontalForm } from "../core/components/HorizontalForm";
import { IconCheckbox } from "../core/components/IconCheckbox";
import { LoadingSpinner } from "../core/components/LoadingSpinner";
import { ProductIcon } from "../core/components/ProductIcon";
import { SelectAllButton } from "../core/components/SelectAllButton";
import { UserRole } from 'legoland-sdk/dist/experimental';
import { Checkbox, Text } from 'tombac';
import { CommunicationType } from "./communicationTypes";
import { useCommunicationProducts } from "./helpers/useCommunicationProducts";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommunicationListFilters = _ref => {
  let {
    filters,
    onChange
  } = _ref;
  const {
    products,
    query: productsQuery
  } = useCommunicationProducts();
  if (productsQuery.isLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (productsQuery.isError) {
    return /*#__PURE__*/_jsx(Text, {
      variant: "secondary",
      children: "Something went wrong"
    });
  }
  const selectedProducts = filters.products ?? [];
  const selectedRoles = filters.roles ?? [];
  const selectedTypes = filters.types ?? [];
  return /*#__PURE__*/_jsxs(HorizontalForm.Root, {
    $pb: "2sp",
    "data-sentry-element": "unknown",
    "data-sentry-component": "CommunicationListFilters",
    "data-sentry-source-file": "CommunicationListFilters.tsx",
    children: [/*#__PURE__*/_jsx(HorizontalForm.Group, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "CommunicationListFilters.tsx",
      "data-sentry-element": "unknown",
      children: /*#__PURE__*/_jsx(CheckboxGroup, {
        label: "Products",
        toolbar: /*#__PURE__*/_jsx(SelectAllButton, {
          areAllSelected: selectedProducts.length === products.length,
          onDeselectAllClick: () => onChange({
            ...filters,
            products: []
          }),
          onSelectAllClick: () => onChange({
            ...filters,
            products: products.map(product => product.id)
          })
        }),
        "data-sentry-element": "CheckboxGroup",
        "data-sentry-source-file": "CommunicationListFilters.tsx",
        "data-sentry-element": "CheckboxGroup",
        children: products.map(product => /*#__PURE__*/_jsx(IconCheckbox, {
          checked: selectedProducts.includes(product.id),
          icon: /*#__PURE__*/_jsx(ProductIcon, {
            height: 24,
            productId: product.id,
            width: 24
          }),
          label: product.displayName,
          onChange: event => onChange({
            ...filters,
            products: handleCheckboxChange(event, selectedProducts)
          }),
          value: product.id
        }, product.id))
      })
    }), /*#__PURE__*/_jsx(HorizontalForm.Group, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "CommunicationListFilters.tsx",
      "data-sentry-element": "unknown",
      children: /*#__PURE__*/_jsx(CheckboxGroup, {
        $minWidth: "120u",
        label: "Roles",
        toolbar: /*#__PURE__*/_jsx(SelectAllButton, {
          areAllSelected: selectedRoles.length === Object.values(UserRole).length,
          onDeselectAllClick: () => onChange({
            ...filters,
            roles: []
          }),
          onSelectAllClick: () => onChange({
            ...filters,
            roles: Object.values(UserRole)
          })
        }),
        "data-sentry-element": "CheckboxGroup",
        "data-sentry-source-file": "CommunicationListFilters.tsx",
        "data-sentry-element": "CheckboxGroup",
        children: Object.keys(UserRole).map(key => /*#__PURE__*/_jsx(Checkbox, {
          $height: "24u",
          checked: selectedRoles.includes(UserRole[key]),
          label: key,
          onChange: event => onChange({
            ...filters,
            roles: handleCheckboxChange(event, selectedRoles)
          }),
          value: UserRole[key]
        }, UserRole[key]))
      })
    }), /*#__PURE__*/_jsx(HorizontalForm.Group, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "CommunicationListFilters.tsx",
      "data-sentry-element": "unknown",
      children: /*#__PURE__*/_jsxs(CheckboxGroup, {
        label: "Type",
        "data-sentry-element": "CheckboxGroup",
        "data-sentry-source-file": "CommunicationListFilters.tsx",
        "data-sentry-element": "CheckboxGroup",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          $height: "24u",
          checked: selectedTypes.includes(CommunicationType.ReleaseNotes),
          label: "Release notes",
          onChange: event => onChange({
            ...filters,
            types: handleCheckboxChange(event, selectedTypes)
          }),
          value: CommunicationType.ReleaseNotes,
          "data-sentry-element": "Checkbox",
          "data-sentry-source-file": "CommunicationListFilters.tsx",
          "data-sentry-element": "Checkbox"
        }), /*#__PURE__*/_jsx(Checkbox, {
          $height: "24u",
          checked: selectedTypes.includes(CommunicationType.EmailOnly),
          label: "Email only",
          onChange: event => onChange({
            ...filters,
            types: handleCheckboxChange(event, selectedTypes)
          }),
          value: CommunicationType.EmailOnly,
          "data-sentry-element": "Checkbox",
          "data-sentry-source-file": "CommunicationListFilters.tsx",
          "data-sentry-element": "Checkbox"
        })]
      })
    })]
  });
};

/**
 * Handles the change of a checkbox.
 *
 * If the checkbox is checked, the value is added to the list. If the checkbox
 * is unchecked, the value is removed from the list.
 *
 * @param event - The change event.
 * @param prev - The previous values.
 * @returns The new values.
 */
function handleCheckboxChange(event, prev) {
  const value = event.target.value;
  if (event.target.checked) {
    return [...prev, value];
  } else {
    return prev.filter(item => item !== value);
  }
}